<template>
  <div>
    <material :actualizar="actualizar" :id ="id" :proveedor="proveedor" :cantidad="cantidad" :tipo_material="tipo_material"/>
    <ListaMateriales @objMaterial="capturarMaterial($event)"/>
    
  </div>
</template>

<script>
import Material from "../components/Material.vue";
import ListaMateriales from "../components/ListaMateriales.vue"; 


export default {
data: ()=>{
    return {
      id:"",
      proveedor: "",
      cantidad: "",
      tipo_material: "",      
      actualizar: false
    }
  },


  components: {
    Material,
    ListaMateriales,   

  },
  methods: {
    capturarMaterial(obj){
      console.log("Estoy en el padre -> ", obj._id);
      this.id= obj._id;
      this.tipo_material = obj.tipo_material;
      this.cantidad = obj.cantidad;
      this.proveedor = obj.proveedor;
      this.actualizar = true;
    }
  }
};
</script>

<style>
</style>